import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { CustomValidator } from '../../shared/_validators/custom-validator';
import { MatTableDataSource } from '@angular/material';
import { DatacontextService } from 'src/app/data/datacontext.service';
import { ActionsCommonService } from '../actions-common.service';
import { AppSelectorService } from 'src/app/shared/services/app-selector/app-selector.service';
import { AmplitudeLoggerService } from 'src/app/shared/services/amplitude-logger/amplitude-logger.service';
import { AnalyticsEvents } from 'src/app/shared/constants/analytics-events';
import { UtilService } from 'src/app/shared/services/util/util.service';

@Component({
  selector: 'app-module-dialog',
  templateUrl: './module-dialog.component.html',
  styleUrls: ['./module-dialog.component.scss']
})
export class ModuleDialogComponent implements OnInit, OnDestroy {
  getTagText: (o: any) => any;
  appObj;
  selectedTabIndex = 0;
  btnPromise: any;
  deepConfigSearchText = '';
  moduleData = {
    app_id: '',
    deepconfig_ids: [],
    module_id: '',
    name: '',
    desc: '',
    updated_ts: 0,
    journey_id: ''
  };
  dcLoading = false;
  deepConfigList = [];
  dataSource = new MatTableDataSource(this.deepConfigList);
  selection = new SelectionModel(true, []);
  displayedColumns: string[] = ['select', 'key', 'details'];

  constructor(
    private dialogRef: MatDialogRef<ModuleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private datacontextService: DatacontextService,
    private actionsCommonService: ActionsCommonService,
    private appSelectorService: AppSelectorService,
    private utilService: UtilService,
    private amplitudeLoggerService: AmplitudeLoggerService
  ) { }

  ngOnInit() {
    this.utilService.hideScrollOnTopMostContainer();
    this.getTagText = this.actionsCommonService.getTagText;
    if (this.data && this.data.module_id) {
      // this.selectedTabIndex = 1;
      this.moduleData = JSON.parse(JSON.stringify(this.data));
    }
    const appId = this.moduleData.app_id ? this.moduleData.app_id : this.appSelectorService.getSelectedApp().id;
    this.getDeepConfigList(appId);
    this.appObj = this.appSelectorService.getSelectedApp();
  }

  ngOnDestroy() {
    this.utilService.removeHideScrollClassFromTopMostContainer();
  }

  buildDeepConfigListParams(app_id) {
    const moduleIdList = this.moduleData.module_id ? [this.moduleData.module_id] : [];
    const dataToSend = {
      'orphan': true,
      'module_ids': moduleIdList,
      'app_id': app_id ? app_id : this.appSelectorService.getSelectedApp().id,
      'q': '',
      'l': 0,
      'o': 0,
    };
    return dataToSend;
  }

  /**
   * Gets Deep Config List from the API
   * Calls processDeepConfigApiResponse to process the response
   */
  getDeepConfigList(app_id) {
    this.dcLoading = true;
    const dataToSend = this.buildDeepConfigListParams(app_id);
    return this.datacontextService.datasource.getDeepConfigList(dataToSend).subscribe((data: any) => {
      this.dcLoading = false;
      if (data.is_error) {
        return;
      }
      this.deepConfigListLoadComplete(data.api_response.deepconfig_list);
    }, (err) => {
      this.dcLoading = false;
    });
  }

  deepConfigListLoadComplete(dcList) {
    this.deepConfigList = dcList;
    this.dataSource = new MatTableDataSource(this.deepConfigList);
    this.selection = new SelectionModel(true, []);
    this.moduleData.deepconfig_ids.forEach(dcId => {
      this.deepConfigList.forEach(dcFromApi => {
        if (dcId === dcFromApi.deepconfig_id) {
          this.selection.select(dcFromApi);
        }
      });
    });
  }

  goToNextTab() {
    this.selectedTabIndex = 1;
  }

  onModuleFormSubmit() {
    const dataToSend = this.moduleData;
    if (!dataToSend.app_id) {
      dataToSend.app_id = this.appSelectorService.getSelectedApp().id;
    }
    dataToSend.deepconfig_ids = [];
    if (this.selection.selected && this.selection.selected.length) {
      dataToSend.deepconfig_ids = this.selection.selected.map(dc => dc.deepconfig_id);
    }
    if (!dataToSend.module_id) {
      this.btnPromise = this.createModule(dataToSend);
    } else {
      this.btnPromise = this.updateModule(dataToSend);
    }

  }

  createModule(dataToSend) {
    return this.datacontextService.datasource.createModuleByParams(
      dataToSend.name,
      dataToSend.desc,
      dataToSend.deepconfig_ids,
      dataToSend.app_id
    ).subscribe((data: any) => {
      if (data.is_error) {
        return;
      }
      this.amplitudeLoggerService.log(
        AnalyticsEvents.eventName.CONFIG_SET_CREATE,
        AnalyticsEvents.eventAction.CREATE_FINISH, {
          app_name: this.appSelectorService.getSelectedApp().name,
          name: dataToSend.name
        }
      );
      dataToSend.module_id = data.api_response.module_id;
      this.dialogRef.close(dataToSend);
    }, (err) => {
    });
  }

  updateModule(dataToSend) {
    return this.datacontextService.datasource.updateModule(
      dataToSend.module_id,
      dataToSend.name,
      dataToSend.desc,
      dataToSend.deepconfig_ids,
      dataToSend.app_id
    ).subscribe((data: any) => {
      if (data.is_error) {
        return;
      }
      this.dialogRef.close('reload');
    }, (err) => {
    });
  }

  /**
   * Whether the number of selected elements matches the total number of rows
   *
   * @return  boolean
   */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /**
   * Selects all rows if they are not all selected; otherwise clear selection
   */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  queryTextChange(text: string) {
    if (this.deepConfigSearchText !== text) {
      this.deepConfigSearchText = text;
      this.applyFilter(this.deepConfigSearchText);
    }
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  isDeepConfigAlreadyAttachedToJourney(deepConfigId) {
    return this.data.deepconfig_ids.find(function (dcId) {
      return dcId === deepConfigId;
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
